import { render, staticRenderFns } from "./MarianaTek.vue?vue&type=template&id=022c0fd3&scoped=true&"
import script from "./MarianaTek.vue?vue&type=script&lang=js&"
export * from "./MarianaTek.vue?vue&type=script&lang=js&"
import style0 from "./MarianaTek.vue?vue&type=style&index=0&id=022c0fd3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c0fd3",
  null
  
)

export default component.exports